export interface IKnowledgeDocumentIcon {
  className: string;
  modifier: string;
  label: string;
}

// O nome do arquivo identifica melhor que o título, que pode ser gerado.
export function documentLabel(document: {
  title: string;
  originalFilename?: string;
}): string {
  return document.originalFilename || document.title;
}

export function knowledgeDocumentIcon(detectedMime?: string): IKnowledgeDocumentIcon {
  const mime = detectedMime ?? '';

  if (mime === 'application/pdf') {
    return { className: 'far fa-file-pdf', modifier: 'pdf', label: 'PDF' };
  }
  if (mime.startsWith('image/')) {
    return { className: 'far fa-file-image', modifier: 'image', label: 'Imagem' };
  }
  if (mime.startsWith('text/')) {
    return { className: 'far fa-file-alt', modifier: 'text', label: 'Texto' };
  }
  return { className: 'far fa-file', modifier: 'generic', label: 'Documento' };
}
